"use client";

import { c as _c } from "react/compiler-runtime";
import { useRef, useState } from "react";
import DropListItemRateGiveChangeButton from "./DropListItemRateGiveChangeButton";
import DropListItemRateGiveSubmit from "./DropListItemRateGiveSubmit";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { Time } from "@/helpers/time";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import { Tooltip } from "react-tooltip";
import { useDropInteractionRules } from "@/hooks/drops/useDropInteractionRules";
export enum RateChangeType {
  INCREASE = "INCREASE",
  DECREASE = "DECREASE",
}
interface ProgressRateState {
  readonly dropId: string;
  readonly rate: number;
}
export default function DropListItemRateGive(t0) {
  const $ = _c(26);
  const {
    drop,
    onRated,
    isMobile: t1
  } = t0;
  const isMobile = t1 === undefined ? false : t1;
  const memeticValues = [-69420, -42069, -6529, -420, -69, 69, 420, 6529, 42069, 69420];
  const {
    canVote
  } = useDropInteractionRules(drop);
  let t2;
  if ($[0] !== drop.id) {
    t2 = {
      dropId: drop.id,
      rate: 1
    };
    $[0] = drop.id;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [progressRateState, setProgressRateState] = useState(t2);
  const maxRating = drop.context_profile_context?.max_rating ?? 0;
  const currentRating = drop.context_profile_context?.rating ?? 0;
  const rawMinRating = drop.context_profile_context?.min_rating ?? 0;
  const minRating = drop.wave.forbid_negative_votes ? Math.max(0, rawMinRating) - currentRating : rawMinRating;
  const rawProgressRate = progressRateState.dropId === drop.id ? progressRateState.rate : 1;
  let t3;
  if ($[2] !== maxRating || $[3] !== minRating) {
    t3 = newValue => {
      if (newValue > maxRating) {
        return maxRating;
      }
      if (newValue < minRating) {
        return minRating;
      }
      return newValue;
    };
    $[2] = maxRating;
    $[3] = minRating;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const getCorrectedNewRate = t3;
  const onProgressRate = canVote ? getCorrectedNewRate(rawProgressRate) : 0;
  const canDecrease = onProgressRate > minRating;
  let t4;
  if ($[5] !== drop.id) {
    t4 = rate => {
      setProgressRateState({
        dropId: drop.id,
        rate
      });
    };
    $[5] = drop.id;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const setOnProgressRate = t4;
  let t5;
  if ($[7] !== onRated || $[8] !== setOnProgressRate) {
    t5 = () => {
      setOnProgressRate(1);
      onRated?.();
    };
    $[7] = onRated;
    $[8] = setOnProgressRate;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const onSuccessfulRateChange = t5;
  const timeoutRef = useRef(null);
  const clearHoldTimer = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  };
  const getIncreaseAmount = _temp;
  const getMemeticNewRate = t6 => {
    const {
      previousRate,
      newRate,
      changeType
    } = t6;
    let finalVal = newRate;
    const values = changeType === RateChangeType.DECREASE ? memeticValues.toReversed() : memeticValues;
    for (const memeticVal of values) {
      if (previousRate < memeticVal && memeticVal < newRate || newRate < memeticVal && memeticVal < previousRate) {
        finalVal = memeticVal;
        break;
      }
    }
    return {
      rate: finalVal,
      isMemetic: values.includes(finalVal)
    };
  };
  let t7;
  if ($[10] !== getCorrectedNewRate) {
    t7 = t8 => {
      const {
        changeType: changeType_0,
        previousRate: previousRate_0,
        startTime: startTime_0
      } = t8;
      const increaseAmount = getIncreaseAmount(startTime_0);
      const newRate_0 = changeType_0 === RateChangeType.INCREASE ? previousRate_0 + increaseAmount : previousRate_0 - increaseAmount;
      const newValue_0 = Math.round(newRate_0 / increaseAmount) * increaseAmount;
      const correctedNewRate = getCorrectedNewRate(newValue_0);
      return {
        rate: correctedNewRate
      };
    };
    $[10] = getCorrectedNewRate;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const getNewRateConfig = t7;
  const modifyRate = t8 => {
    const {
      changeType: changeType_1,
      intervalTime,
      previousRate: previousRate_1,
      startTime: startTime_1
    } = t8;
    const {
      rate: newRate_1
    } = getNewRateConfig({
      changeType: changeType_1,
      previousRate: previousRate_1,
      startTime: startTime_1
    });
    const {
      rate: memeticRate,
      isMemetic
    } = getMemeticNewRate({
      previousRate: previousRate_1,
      newRate: newRate_1,
      changeType: changeType_1
    });
    setOnProgressRate(memeticRate);
    if (changeType_1 === RateChangeType.DECREASE && memeticRate <= minRating || changeType_1 === RateChangeType.INCREASE && memeticRate >= maxRating) {
      clearHoldTimer();
      return;
    }
    const newIntervalTime = Math.max(10, intervalTime * 0.9);
    const waitForMemetic = isMemetic ? 1000 : newIntervalTime;
    timeoutRef.current = setTimeout(() => modifyRate({
      intervalTime: isMemetic && newIntervalTime < 300 ? 300 : newIntervalTime,
      changeType: changeType_1,
      previousRate: memeticRate,
      startTime: isMemetic ? startTime_1 + 1000 : startTime_1
    }), waitForMemetic);
  };
  const handleMouseDown = changeType_2 => {
    modifyRate({
      intervalTime: 500,
      changeType: changeType_2,
      previousRate: onProgressRate,
      startTime: Time.now().toMillis()
    });
  };
  const handleMouseUp = () => {
    clearHoldTimer();
  };
  const getRateText = () => `${onProgressRate > 0 ? "+" : ""}${formatNumberWithCommas(onProgressRate)}`;
  const getShowRate = () => canVote && onProgressRate !== 0 && onProgressRate !== 1;
  const getRateClasses = () => {
    if (onProgressRate > 0) {
      return "tw-text-green";
    }
    if (onProgressRate < 0) {
      return "tw-text-red";
    }
    return "tw-text-iron-500";
  };
  const tooltipId = `rate-give-tooltip-${drop.id}`;
  let t9;
  if ($[12] !== getShowRate || $[13] !== tooltipId) {
    t9 = getShowRate() ? {
      "data-tooltip-id": tooltipId
    } : {};
    $[12] = getShowRate;
    $[13] = tooltipId;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== canVote || $[16] !== drop || $[17] !== isMobile || $[18] !== onProgressRate || $[19] !== onSuccessfulRateChange) {
    t10 = <DropListItemRateGiveSubmit rate={onProgressRate} drop={drop} canVote={canVote} onSuccessfulRateChange={onSuccessfulRateChange} isMobile={isMobile} />;
    $[15] = canVote;
    $[16] = drop;
    $[17] = isMobile;
    $[18] = onProgressRate;
    $[19] = onSuccessfulRateChange;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== canVote || $[22] !== handleMouseDown || $[23] !== handleMouseUp || $[24] !== isMobile) {
    t11 = <DropListItemRateGiveChangeButton canVote={canVote} type={RateChangeType.INCREASE} handleMouseDown={handleMouseDown} handleMouseUp={handleMouseUp} isMobile={isMobile} />;
    $[21] = canVote;
    $[22] = handleMouseDown;
    $[23] = handleMouseUp;
    $[24] = isMobile;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  return <><div className="tw-relative tw-flex tw-flex-col tw-items-center tw-gap-y-1" {...t9}><div className={`${isMobile ? "tw-gap-x-4" : ""} tw-inline-flex tw-w-full tw-items-center tw-gap-x-1`}><DropListItemRateGiveChangeButton canVote={canVote && canDecrease} type={RateChangeType.DECREASE} handleMouseDown={handleMouseDown} handleMouseUp={handleMouseUp} isMobile={isMobile} />{t10}{t11}</div></div>{getShowRate() && <Tooltip id={tooltipId} place="top" style={{
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px"
    }}><div className="tw-text-center"><span className={`${getRateClasses()} tw-w-full tw-text-center tw-text-xs tw-font-normal tw-transition tw-duration-300 tw-ease-out`}>{getRateText()}</span></div></Tooltip>}</>;
}
function _temp(startTime) {
  const elapsedSeconds = (Time.now().toMillis() - startTime) / 1000;
  if (elapsedSeconds < 2) {
    return 1;
  }
  if (elapsedSeconds < 4) {
    return 10;
  }
  if (elapsedSeconds < 6) {
    return 100;
  }
  return 1000;
}